import { cva } from 'class-variance-authority';

export const baseTitleVariants = cva(
  'c-base-title',
  {
    variants: {
      variant: {
        default: 'c-base-title--left',
        center: 'c-base-title--center',
        right: 'c-base-title--right',
      },
      size: {
        default: 'c-base-title--medium',
        tiny: 'c-base-title--tiny',
        small: 'c-base-title--small',
        large: 'c-base-title--large',
        bag: 'c-base-title--bag',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
